import { NewsTranslationDTO } from "../domain/models/dto/NewsDTO";
import { IFile } from "../domain/models/File";
import { INews } from "../domain/models/News";
import { BaseModelImpl } from "./BaseModelImpl";

export class NewsModel extends BaseModelImpl<INews> implements INews {
    id: string;
    files?: IFile[];

    translations: NewsTranslationDTO[];
    availableLangs?: string[];

    creatorId: string;
    createdAt?: Date;
    updatedAt?: Date;

    constructor(data?: INews) {
        super();
        this.assignData(data);
    }
}
